export default class TsSearchObj {
    constructor(param, name, value, type = 'numberRange', label) {
      this._type = type;
      this._name = name;
      this._value = value;
      this._param = param;
      this._label = label;
    }

    get tags() {
      let label = this._label ? this._label : '';
      if (this._type === 'numberRange' || this._type === 'numberRangeArr') {
        label = `${this._value[0]}~${this._value[1]}`;
      }
      if (this._type === 'dateRangeArr') {
        label = `${this._value[0]}~${this._value[1]}`;
      }


      return {
        name: this._name,
        type: this._type,
        value: this._value,
        param: this._param,
        label
      };
    }
  }
